import React, { useEffect } from "react"
import { SystemUpdateAlt as SystemUpdateAltIcon } from "@material-ui/icons"
import Config from "react-global-configuration"
import { getClientVersion } from "../../data"
import { useSnackbar } from "../SnackbarProvider"

const handleVersionCheck = (props) => {
  const { intervalMs, onNewVersionAvailable } = props
  console.log("[APP]", "Running version check")
  getClientVersion().then((newVersionAvailable) => {
    if (newVersionAvailable) {
      onNewVersionAvailable()
    }
    setTimeout(() => handleVersionCheck(props), intervalMs)
  })
}

const handleNewVersionReloading = (snackbar) => {
  console.log("[APP]", "New version, reloading")
  snackbar.showMessage({
    message: "A new version is available, downloading.",
    icon: <SystemUpdateAltIcon />,
    chipProps: { style: { cursor: "pointer", backgroundColor: "#fd9317" } },
    keepOpen: true,
  })
  window.location.reload(true)
}

const handleNewVersionAvailable = (snackbar) => {
  snackbar.showMessage({
    message: "A new version is available. Click here to update.",
    icon: <SystemUpdateAltIcon />,
    onClick: () => window.location.reload(true),
    chipProps: { style: { cursor: "pointer", backgroundColor: "#fd9317" } },
    keepOpen: true,
  })
}

const VersionCheck = () => {
  const snackbar = useSnackbar()

  useEffect(() => {
    const {
      check: { enabled, intervalMs },
    } = Config.get("version")
    if (enabled) {
      setTimeout(async () => {
        console.log("[APP]", "Running first load version check")
        const newVersionAvailable = await getClientVersion()
        if (newVersionAvailable) {
          handleNewVersionReloading(snackbar)
        } else {
          setTimeout(
            () => handleVersionCheck({ intervalMs, onNewVersionAvailable: () => handleNewVersionAvailable(snackbar) }),
            intervalMs
          ) // start further version checks
        }
      }, 1000)
    }
  }, [snackbar])

  return null
}

export { VersionCheck }
